import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
  QueryList,
  ViewChildren,
  OnDestroy, Input
} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ReportsService} from "../../../reports.service";
import {CurrentRouteService} from "../../../../currentRoute.service";
import {AccountIdService, AgencyIdService} from "../../../../account.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ThemePalette} from '@angular/material/core';
import {environment} from '../../../../../environments/environment';
import * as _moment from 'moment';
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";
import {AdgroupIdInterfaceData, CampaignIdInterfaceData} from "../../../../shared/models/adwords.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatAccordion} from "@angular/material/expansion";

import { Observable, interval, pipe } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';


@Component({
  selector: 'app-include-first-click',
  templateUrl: './include-first-click.component.html',
  styleUrls: ['./include-first-click.component.css']
})
export class IncludeFirstClickComponent implements OnInit, OnDestroy {


  @Input() data: any = [];

  data_email: any = [];
  data_form: any = [];
  data_clickfunnels: any = [];
  data_calendly: any = [];

  is_table_column_hidden: boolean = false;

  displayedColumnsCf: string[] = ['purchase_dt','service','amount', 'description', 'fullName','emailAddress','phoneNumberStandard', 'first_event_dt','first_action_id', 'first_provider', 'first_source_name','star'];
  dataSourceCf: MatTableDataSource<CampaignIdInterfaceData>;

  displayedColumnsCalendly: string[] = ['purchase_dt','service', 'fullName','emailAddress','phoneNumberStandard', 'first_event_dt','first_action_id', 'first_provider', 'first_source_name','star'];
  dataSourceCalendly: MatTableDataSource<CampaignIdInterfaceData>;

  displayedColumnsEmail: string[] = ['purchase_dt','service', 'fullName','emailAddress','phoneNumberStandard', 'first_event_dt','first_action_id', 'first_provider', 'first_source_name','star'];
  dataSourceEmail: MatTableDataSource<CampaignIdInterfaceData>;

  displayedColumnsForm: string[] = ['purchase_dt','service', 'fullName','emailAddress','phoneNumberStandard', 'first_event_dt','first_action_id', 'first_provider', 'first_source_name','star'];
  dataSourceForm: MatTableDataSource<CampaignIdInterfaceData>;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {} // end ngOnInit

  ngOnDestroy(): void {} // end ngOnDestroy

  ngOnChanges(): void {
    //If we dont re init data is appended to the table on resubmit thus adding previous data to the table
    this.data_email = [];
    this.data_form = [];
    this.data_clickfunnels = [];
    this.data_calendly = [];

    for (let i = 0; i < this.data.length; i++) {
      let service = this.data[i]['service'];

      if (service == 'email') {
        this.data_email.push(this.data[i]);
      } else if (service == 'form') {
        this.data_form.push(this.data[i]);
      } else if (service == 'clickfunnels') {
        this.data_clickfunnels.push(this.data[i]);
      } else if (service == 'calendly') {
        this.data_calendly.push(this.data[i]);
      }
    } //end for

    this.loadTables()
  } // end ngOnChanges

  loadTables() {

    let idx = 0   //only inc the idx if we have data -- order I guess matters how one init the table

    if (this.data_clickfunnels.length > 0) {
      this.dataSourceCf = new MatTableDataSource(this.data_clickfunnels);
      this.cdr.detectChanges();
      this.dataSourceCf.paginator = this.paginator.toArray()[idx];
      this.dataSourceCf.sort = this.sort.toArray()[idx];
      idx = idx + 1
    }

    if (this.data_calendly.length > 0) {
      this.dataSourceCalendly = new MatTableDataSource(this.data_calendly);
      this.cdr.detectChanges();
      this.dataSourceCalendly.paginator = this.paginator.toArray()[idx];
      this.dataSourceCalendly.sort = this.sort.toArray()[idx];
       idx = idx + 1
    }

    if (this.data_email.length > 0) {
      this.dataSourceEmail = new MatTableDataSource(this.data_email);
      this.cdr.detectChanges();
      this.dataSourceEmail.paginator = this.paginator.toArray()[idx];
      this.dataSourceEmail.sort = this.sort.toArray()[idx];
      idx = idx + 1
    }

    if (this.data_form.length > 0) {
      this.dataSourceForm = new MatTableDataSource(this.data_form);
      this.cdr.detectChanges();
      this.dataSourceForm.paginator = this.paginator.toArray()[idx];
      this.dataSourceForm.sort = this.sort.toArray()[idx];
      idx = idx + 1
    }




  }// end loadTables

  applyFilterClickfunnels(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCf.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceCf.paginator) {
      this.dataSourceCf.paginator.firstPage();
    }
  } // applyFilter

  applyFilterEmail(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceEmail.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceEmail.paginator) {
      this.dataSourceEmail.paginator.firstPage();
    }
  } // applyFilter

  applyFilterForm(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceForm.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceForm.paginator) {
      this.dataSourceForm.paginator.firstPage();
    }
  } // applyFilter

  applyFilterCalendy(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCalendly.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceCalendly.paginator) {
      this.dataSourceCalendly.paginator.firstPage();
    }
  } // applyFilter

  getTableRecord(row) {
  } // end getTableRecord( )

}
